var map = {
	"./19-0919_1.jpg": "OiMv",
	"./19-0919_2.jpg": "WCVd",
	"./19-0921_1.jpg": "leck",
	"./19-0921_2.jpg": "NiLs",
	"./19-0921_3.jpg": "O8yd",
	"./19-0921_4.jpg": "xl/p",
	"./2018ltyj.jpg": "Kinj",
	"./2018ltyj2.jpg": "hf8u",
	"./2018ltyj3.jpg": "OqzM",
	"./301.jpg": "CSwg",
	"./302.jpg": "2eUj",
	"./303.jpg": "5AOT",
	"./304.jpg": "O99h",
	"./305.jpg": "ktqw",
	"./banner.png": "4neo",
	"./bup1.jpeg": "1YZ8",
	"./bup2.jpeg": "Qq6I",
	"./bup3.jpeg": "O7aj",
	"./cM1.jpg": "yKO6",
	"./cM12.jpg": "9+Gl",
	"./cls-yj0.jpg": "pUK0",
	"./cls-yj1.jpg": "dVw+",
	"./cls-yj2.jpg": "jwrs",
	"./cls-yj3.jpg": "M8Uo",
	"./cls-yj4.jpg": "eRgO",
	"./jjzx.jpg": "VWFq",
	"./jrj1.jpg": "UvQU",
	"./jrj2.jpg": "sA4G",
	"./jrj3.jpg": "UP39",
	"./jrj4.jpg": "hbfT",
	"./jrsl.jpg": "09XL",
	"./news-cover.jpg": "h4PF",
	"./news-cqw.jpg": "c+4L",
	"./news-wz1.jpg": "2fQV",
	"./news-wz2.jpg": "DcJb",
	"./news-wz3.jpg": "lbdu",
	"./news1-1.jpg": "GVZi",
	"./news1.png": "HUlT",
	"./news2.jpg": "9mM8",
	"./news3.jpg": "gddB",
	"./news6_1.jpg": "q4f+",
	"./news6_2.jpg": "Ak++",
	"./news6_3.jpg": "BCe6",
	"./symbol-left.png": "cj2I",
	"./symbol-right.png": "tyvL",
	"./xfxb1.jpg": "qieI",
	"./xfxb2.jpg": "7vez",
	"./xfxb3.jpg": "NKFZ",
	"./xfxb4.jpg": "eUXC",
	"./xfxb5.jpg": "so3g",
	"./ybl1.jpg": "1c6q",
	"./ybl2.jpg": "hveX",
	"./ybl3.jpg": "hbpK",
	"./ycls1.jpg": "T/V0",
	"./ycls10.jpg": "yMnY",
	"./ycls11.jpg": "j4as",
	"./ycls12.jpg": "bszU",
	"./ycls13.jpg": "oqE8",
	"./ycls2.jpg": "mrS+",
	"./ycls3.jpg": "NSaQ",
	"./ycls4.jpg": "87Xt",
	"./ycls5.jpg": "jrXz",
	"./ycls6.jpg": "nVUn",
	"./ycls7.jpg": "8dt8",
	"./ycls8.jpg": "qYdv",
	"./ycls9.jpg": "AYRv",
	"./yn1.jpg": "GRko",
	"./yn2.jpg": "lehs",
	"./zfcqw.jpg": "e6Uy",
	"./zjg1.jpg": "xFTy",
	"./zjg2.jpg": "BUbr",
	"./zjgzt.jpg": "HJuI",
	"./zmrs1.png": "lbTt",
	"./zmrs2.png": "oscA",
	"./zmrs3.png": "ex86",
	"./zmrs4.png": "cSQP",
	"./zmrs5.png": "ZZuC",
	"./zmrs6.png": "GpyM",
	"./zq1.jpeg": "K2rr",
	"./zq2.jpeg": "pfm0",
	"./新闻1.jpg": "QztW"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2Mzb";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsDetail/images ^\.\/.*$
// module id = 2Mzb
// module chunks = 0